module.exports = __webpack_public_path__ + "img/manage-3.7021cfd3.png";